export const props = {
  // Values
  header: [Array, Object],
  list: [Array, Object],

  // Options
  headerShow: {
    type: Boolean,
    default: true
  },
  limit: Number
}
